import { ContactsBirthdate, UrlInput, Header, RichText, SubmitButton, FileUpload, QuizFileUpload, NestedForm, MultilineAddress, MlaCountry, MlaAddressLine, MlaPostalCode, MlaSubdivision, MlaStreetName, VatId, EcomAddress, DextUrlInput, ContactsDateInput, DateInput, DateTimeInput, TimeInput, ProductList, EcomFullName, EcomHeader, FullName, Signature } from './fields';
import { ContactsAddressWUT } from './fields/contacts-address/contacts-address/contacts-address-wut';
import { ContactsCompanyWUT } from './fields/contacts-company/contacts-company/contacts-company-wut';
import { ContactsEmailWUT } from './fields/contacts-email/contacts-email/contacts-email-wut';
import { ContactsFirstNameWUT } from './fields/contacts-first-name/contacts-first-name/contacts-first-name-wut';
import { ContactsLastNameWUT } from './fields/contacts-last-name/contacts-last-name/contacts-last-name-wut';
import { ContactsPhoneWUT } from './fields/contacts-phone/contacts-phone/contacts-phone-wut';
import { ContactsPositionWUT } from './fields/contacts-position/contacts-position/contacts-position-wut';
import { ContactsTaxIdWUT } from './fields/contacts-tax-id/contacts-tax-id/contacts-tax-id-wut';
import { ContactsTextInputWUT } from './fields/contacts-text-input/contacts-text-input/contacts-text-input-wut';
import { ContactsUrlInputWUT } from './fields/contacts-url-input/contacts-url-input/contacts-url-input-wut';
import { ContactsNumberInputWUT } from './fields/contacts-number-input/contacts-number-input/contacts-number-input-wut';
import { ContactsSubscribeWUT } from './fields/contacts-subscribe/contacts-subscribe/contacts-subscribe-wut';
import { DextEmailWUT } from './fields/dext-email/dext-email/dext-email-wut';
import { DextPhoneWUT } from './fields/dext-phone/dext-phone/dext-phone-wut';
import { DextTextInputWUT } from './fields/dext-text-input/dext-text-input/dext-text-input-wut';
import { DextTextAreaWUT } from './fields/dext-text-area/dext-text-area/dext-text-area-wut';
import { DextNumberInputWUT } from './fields/dext-number-input/dext-number-input/dext-number-input-wut';
import { DextDropdownWUT } from './fields/dext-dropdown/dext-dropdown/dext-dropdown-wut';
import { DextCheckboxWUT } from './fields/dext-checkbox/dext-checkbox/dext-checkbox-wut';
import { DextCheckboxGroupWUT } from './fields/dext-checkbox-group/dext-checkbox-group/dext-checkbox-group-wut';
import { DextRadioGroupWUT } from './fields/dext-radio-group/dext-radio-group/dext-radio-group-wut';
import { TextInputWUT } from './fields/text-input/text-input/text-input-wut';
import { TextAreaWUT } from './fields/text-area/text-area/text-area-wut';
import { QuizShortTextWUT } from './fields/quiz-short-text/quiz-short-text/quiz-short-text-wut';
import { QuizLongTextWUT } from './fields/quiz-long-text/quiz-long-text/quiz-long-text-wut';
import { QuizNumberWUT } from './fields/quiz-number/quiz-number/quiz-number-wut';
import { QuizMultiChoiceWUT } from './fields/quiz-multi-choice/quiz-multi-choice/quiz-multi-choice-wut';
import { QuizSingleChoiceWUT } from './fields/quiz-single-choice/quiz-single-choice/quiz-single-choice-wut';
import { MlaAddressLine2WUT } from './fields/mla-address-line-2/mla-address-line-2/mla-address-line-2-wut';
import { MlaApartmentWUT } from './fields/mla-apartment/mla-apartment/mla-apartment-wut';
import { MlaStreetNumberWUT } from './fields/mla-street-number/mla-street-number/mla-street-number-wut';
import { MlaCityWUT } from './fields/mla-city/mla-city/mla-city-wut';
import { EcomAdditionalInfoWUT } from './fields/ecom-additional-info/ecom-additional-info/ecom-additional-info-wut';
import { EcomCompanyNameWUT } from './fields/ecom-company-name/ecom-company-name/ecom-company-name-wut';
import { EcomEmailWUT } from './fields/ecom-email/ecom-email/ecom-email-wut';
import { EcomPhoneWUT } from './fields/ecom-phone/ecom-phone/ecom-phone-wut';
import { FullNameFirstNameWUT } from './fields/full-name-first-name/full-name-first-name/full-name-first-name-wut';
import { FullNameLastNameWUT } from './fields/full-name-last-name/full-name-last-name/full-name-last-name-wut';
import { NumberInputWUT } from './fields/number-input/number-input/number-input-wut';
import { DropdownWUT } from './fields/dropdown/dropdown/dropdown-wut';
import { CheckboxWUT } from './fields/checkbox/checkbox/checkbox-wut';
import { CheckboxGroupWUT } from './fields/checkbox-group/checkbox-group/checkbox-group-wut';
import { RadioGroupWUT } from './fields/radio-group/radio-group/radio-group-wut';
import { DonationWUT } from './fields/donation/donation/donation-wut';
import { FIELD_TYPES } from './constants/field-types';
export const INPUT_ELEMENTS = {
  [FIELD_TYPES.ECOM_ADDITIONAL_INFO]: EcomAdditionalInfoWUT,
  [FIELD_TYPES.RICH_TEXT]: RichText,
  [FIELD_TYPES.HEADER]: Header,
  [FIELD_TYPES.SUBMIT_BUTTON]: SubmitButton,
  [FIELD_TYPES.CHECKBOX]: CheckboxWUT,
  [FIELD_TYPES.DATE_INPUT]: DateInput,
  [FIELD_TYPES.DATE_TIME_INPUT]: DateTimeInput,
  [FIELD_TYPES.TIME_INPUT]: TimeInput,
  [FIELD_TYPES.DROPDOWN]: DropdownWUT,
  [FIELD_TYPES.RADIO_GROUP]: RadioGroupWUT,
  [FIELD_TYPES.CHECKBOX_GROUP]: CheckboxGroupWUT,
  [FIELD_TYPES.NUMBER_INPUT]: NumberInputWUT,
  [FIELD_TYPES.QUIZ_NUMBER]: QuizNumberWUT,
  [FIELD_TYPES.QUIZ_SHORT_TEXT]: QuizShortTextWUT,
  [FIELD_TYPES.QUIZ_LONG_TEXT]: QuizLongTextWUT,
  [FIELD_TYPES.QUIZ_MULTI_CHOICE]: QuizMultiChoiceWUT,
  [FIELD_TYPES.QUIZ_SINGLE_CHOICE]: QuizSingleChoiceWUT,
  [FIELD_TYPES.QUIZ_FILE_UPLOAD]: QuizFileUpload,
  [FIELD_TYPES.FILE_UPLOAD]: FileUpload,
  [FIELD_TYPES.CONTACTS_EMAIL]: ContactsEmailWUT,
  [FIELD_TYPES.CONTACTS_BIRTHDATE]: ContactsBirthdate,
  [FIELD_TYPES.CONTACTS_PHONE]: ContactsPhoneWUT,
  [FIELD_TYPES.URL_INPUT]: UrlInput,
  [FIELD_TYPES.CONTACTS_COMPANY]: ContactsCompanyWUT,
  [FIELD_TYPES.CONTACTS_POSITION]: ContactsPositionWUT,
  [FIELD_TYPES.CONTACTS_TAX_ID]: ContactsTaxIdWUT,
  [FIELD_TYPES.CONTACTS_FIRST_NAME]: ContactsFirstNameWUT,
  [FIELD_TYPES.CONTACTS_LAST_NAME]: ContactsLastNameWUT,
  [FIELD_TYPES.CONTACTS_ADDRESS]: ContactsAddressWUT,
  [FIELD_TYPES.CONTACTS_DATE_INPUT]: ContactsDateInput,
  [FIELD_TYPES.CONTACTS_NUMBER_INPUT]: ContactsNumberInputWUT,
  [FIELD_TYPES.CONTACTS_TEXT_INPUT]: ContactsTextInputWUT,
  [FIELD_TYPES.CONTACTS_URL_INPUT]: ContactsUrlInputWUT,
  [FIELD_TYPES.TEXT_INPUT]: TextInputWUT,
  [FIELD_TYPES.TEXT_AREA]: TextAreaWUT,
  [FIELD_TYPES.CONTACTS_SUBSCRIBE]: ContactsSubscribeWUT,
  [FIELD_TYPES.MULTILINE_ADDRESS]: MultilineAddress,
  [FIELD_TYPES.NESTED_FORM]: NestedForm,
  [FIELD_TYPES.MLA_COUNTRY]: MlaCountry,
  [FIELD_TYPES.MLA_CITY]: MlaCityWUT,
  [FIELD_TYPES.MLA_ADDRESS_LINE]: MlaAddressLine,
  [FIELD_TYPES.MLA_ADDRESS_LINE_2]: MlaAddressLine2WUT,
  [FIELD_TYPES.MLA_POSTAL_CODE]: MlaPostalCode,
  [FIELD_TYPES.MLA_SUBDIVISION]: MlaSubdivision,
  [FIELD_TYPES.MLA_STREET_NAME]: MlaStreetName,
  [FIELD_TYPES.MLA_STREET_NUMBER]: MlaStreetNumberWUT,
  [FIELD_TYPES.MLA_APARTMENT]: MlaApartmentWUT,
  [FIELD_TYPES.FULL_NAME]: FullName,
  [FIELD_TYPES.FULL_NAME_FIRST_NAME]: FullNameFirstNameWUT,
  [FIELD_TYPES.FULL_NAME_LAST_NAME]: FullNameLastNameWUT,
  [FIELD_TYPES.VAT_ID]: VatId,
  [FIELD_TYPES.DEXT_TEXT_INPUT]: DextTextInputWUT,
  [FIELD_TYPES.DEXT_TEXT_AREA]: DextTextAreaWUT,
  [FIELD_TYPES.DEXT_DROPDOWN]: DextDropdownWUT,
  [FIELD_TYPES.DEXT_RADIO_GROUP]: DextRadioGroupWUT,
  [FIELD_TYPES.DEXT_URL_INPUT]: DextUrlInput,
  [FIELD_TYPES.DEXT_EMAIL]: DextEmailWUT,
  [FIELD_TYPES.DEXT_PHONE]: DextPhoneWUT,
  [FIELD_TYPES.DEXT_NUMBER_INPUT]: DextNumberInputWUT,
  [FIELD_TYPES.DEXT_CHECKBOX]: DextCheckboxWUT,
  [FIELD_TYPES.DEXT_CHECKBOX_GROUP]: DextCheckboxGroupWUT,
  [FIELD_TYPES.ECOM_ADDRESS]: EcomAddress,
  [FIELD_TYPES.ECOM_FULL_NAME]: EcomFullName,
  [FIELD_TYPES.ECOM_PHONE]: EcomPhoneWUT,
  [FIELD_TYPES.ECOM_COMPANY_NAME]: EcomCompanyNameWUT,
  [FIELD_TYPES.ECOM_EMAIL]: EcomEmailWUT,
  [FIELD_TYPES.ECOM_CONTACT_DETAILS]: EcomHeader,
  [FIELD_TYPES.ECOM_SHIPPING_DETAILS]: EcomHeader,
  [FIELD_TYPES.PRODUCT_LIST]: ProductList,
  [FIELD_TYPES.DONATION]: DonationWUT,
  [FIELD_TYPES.SIGNATURE]: Signature
};
//# sourceMappingURL=form-fields-wut.js.map